import React, { useState } from 'react';
import classNames from 'classnames';
import Filters from '../detail-components/filters';
import PanelHeader from './panel-header';
import './filter-panel.scss';

const FilterPanel = ({
    units,
    allUnits,
    totalUnitsInAreas,
    numberOfUnits,
    filters,
    onApplyFilters,
    onApplyFiltersFromDistrict,
    activeDistrictId,
    activeDistrict,
    allDistricts,
    unitsVisible,
    type,
    onBack,
    ...props
}) => {
    const [filtersVersion, setFiltersVersion] = useState(0);
    const [isCopyingFiltersOpen, setIsCopyingFiltersOpen] = useState(false);

    if (!Array.isArray(allDistricts)) {
        return null;
    }

    const districtId = props.match?.params?.id ? Number(props.match.params.id) : null;
    const district = allDistricts.find((item) => item && item.id === districtId);
    
    if (!district || !district.allUnits || district.allUnits.length === 0) return null;

    const sourceDistrictOptions = allDistricts
        .filter((item) => item && item.id !== activeDistrictId)
        .map((item) => ({
            value: String(item.id),
            label: item.name && item.name.trim().length > 0 ? item.name : `Distrikt ${item.id}`
        }));

    const handleApplyFiltersFromDistrict = async (sourceDistrictId) => {
        if (!onApplyFiltersFromDistrict) {
            return;
        }

        await onApplyFiltersFromDistrict(sourceDistrictId);
        setFiltersVersion((prevVersion) => prevVersion + 1);
    };

    const filtersComponentKey = `${district.id}-${filtersVersion}`;

    return (
        <div className="create-district-map__filter-panel-container">
            <header className="filter-panel__header">
                <div className="filter-panel__header-top">
                    <button type="button" className="filter-panel__back-button" onClick={onBack}>
                        Tillbaka    
                    </button>
                    <h1 className="panel-header__title">
                        <span className="panel-header__district-color" style={{ backgroundColor: activeDistrict?.color }}></span>
                        <span>{activeDistrict?.name || ''}</span>
                    </h1>
                </div>
                <PanelHeader
                    district={activeDistrict}
                    type={type}
                    compact={true}
                    hideFilterButton={true}
                />
            </header>
            <aside className={classNames({
                'filter-panel': true,
                'filter-panel--is-open': true
            })}>
                <Filters 
                    key={filtersComponentKey}
                    isCopyingFiltersOpen={isCopyingFiltersOpen}
                    onToggleCopyingFilters={() => setIsCopyingFiltersOpen((isOpen) => !isOpen)}
                    units={district.units}
                    allUnits={district.allUnits}
                    totalUnitsInAreas={totalUnitsInAreas}
                    numberOfUnits={numberOfUnits}
                    filters={district.salesDistrictFilters}
                    applyFilters={onApplyFilters}
                    applyFiltersFromDistrict={handleApplyFiltersFromDistrict}
                    sourceDistrictOptions={sourceDistrictOptions}
                    type={type}
                    unitsVisible={unitsVisible}
                />
            </aside>
        </div>
    );
};

export default FilterPanel;

